export { p as pluralize } from '../../pluralize-909fde53.js';

var formatPersonalNumber = function (personalNumber) {
    return personalNumber.replace(/^([0-9]{8})\-?([0-9]{4})$/, "$1-$2");
};

var isPersonalNumber = function (personalNumber) {
    var regExp = new RegExp(/^[0-9]{8}\-?[0-9]{4}$/);
    return regExp.test(personalNumber);
};

export { formatPersonalNumber, isPersonalNumber };
//# sourceMappingURL=index.js.map
